import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ user, children }) => {
  const location = useLocation(); // To save the current path

  if (localStorage.getItem("token") === null) {
    // If not logged in, redirect to login with the original location saved
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (
    user &&
    user.role === "admin" &&
    ["/locations", "/users"].includes(location.pathname)
  ) {
    return <Navigate to="/error-403" />;
  }

  // If logged in, allow access to the route
  return children;
};

export default ProtectedRoute;
